import React, { useState, useEffect } from "react";
import { Plus } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import apiService from "../../services/apiService";
import { toast } from "react-toastify";

const EditSlot = () => {
  const navigate = useNavigate();
  const { slot_id } = useParams();

  const [content, setContent] = useState({
    channel_id: "",
    channel_name: "",
    name: "",
    description: "",
    start_time: "",
    end_time: "",
  });

  useEffect(() => {
    if (slot_id) {
      fetchSlot();
    }
  }, [slot_id]);

  const fetchSlot = async () => {
    try {
      const res = await apiService.fetchData(`admin/slot/${slot_id}`);
      if (!res.error && res.data) {
        setContent({
          channel_id: res.data.channel_id || "",
          channel_name: res.data.Channel?.name || "",  // Adding Channel name to state
          name: res.data.name || "",
          description: res.data.description || "",
          start_time: res.data.start_time || "",
          end_time: res.data.end_time || "",
        });
      }
    } catch (err) {
      toast.error("Error fetching slot.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContent({ ...content, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in content) {
      formData.append(key, content[key]);
    }

    try {
      const response = await apiService.putData(`admin/slot/${slot_id}`, formData);
      toast.success("Slot updated successfully!");
      navigate("/radio");
    } catch (error) {
      console.error("Error updating slot:", error);
      toast.error("Error updating slot.");
    }
  };

  return (
    <div className="row">
      <div className="col-12 col-md-12">
        <div className="card">
          <div className="card-header">
            <h4>Edit Slot</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Channel</label>
                <input
                  type="text"
                  className="form-control"
                  value={content.channel_name} // Show channel name
                  disabled // Keep the field read-only
                />
              </div>

              <div className="form-group">
                <label>Show Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={content.name}
                  onChange={handleChange}
                  placeholder="Enter Show Name"
                />
              </div>

              <div className="form-group">
                <label>Show Description</label>
                <textarea
                  name="description"
                  className="form-control"
                  value={content.description}
                  onChange={handleChange}
                  placeholder="Enter Show Description"
                ></textarea>
              </div>

              <div className="form-group">
                <label>Start Time</label>
                <input
                  type="time"
                  name="start_time"
                  className="form-control"
                  value={content.start_time}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>End Time</label>
                <input
                  type="time"
                  name="end_time"
                  className="form-control"
                  value={content.end_time}
                  onChange={handleChange}
                />
              </div>

              <div className="d-flex gap-2 mt-3">
                <button type="submit" className="btn btn-primary">
                  <Plus size={16} /> Update Slot
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/radio")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSlot;
